import { render, staticRenderFns } from "./ListaRetorno.vue?vue&type=template&id=7c37a556&scoped=true"
import script from "./ListaRetorno.vue?vue&type=script&lang=js"
export * from "./ListaRetorno.vue?vue&type=script&lang=js"
import style0 from "./ListaRetorno.vue?vue&type=style&index=0&id=7c37a556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c37a556",
  null
  
)

export default component.exports